import { useContext } from "react";

import { QueryTrackingContext } from "@/stores/QueryTrackingContext";
import { throwExpression } from "@/utils/util";
import { UseQueryResult } from "@tanstack/react-query";

/** Hook to get all tracked queries from the `QueryTrackingContext` **/
export function useRenderedQueries(): UseQueryResult[] {
  const context =
    useContext(QueryTrackingContext) ??
    throwExpression("useTrackedQueries must be used within a QueryTrackingProvider");
  return context.getQueries();
}
